import { render, staticRenderFns } from "./SpineSegment.vue?vue&type=template&id=1600353c&scoped=true&"
import script from "./SpineSegment.vue?vue&type=script&lang=js&"
export * from "./SpineSegment.vue?vue&type=script&lang=js&"
import style0 from "./SpineSegment.vue?vue&type=style&index=0&id=1600353c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600353c",
  null
  
)

export default component.exports